import React, { useContext } from 'react'
import RSRLMultipleBar from './RSRLMultipleBar'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default (props) => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlIndicateursXlsxOccupation.edges
  const page = props.page
  const slug = useContext(AccordionContext)

  let labels = edges.map((row, i) => row.node.TAUX)

  let values2018 = edges.map((row, i) => row.node._2018)
  let values2019 = edges.map((row, i) => row.node._2019)
  let values2020 = edges.map((row, i) => row.node._2020)
  let values2021 = edges.map((row, i) => row.node._2021)
  let values2022 = edges.map((row, i) => row.node._2022)
  let datasets = [
    // {
    //   borderWidth: 0,
    //   stack: '2016',
    //   label: '2016',
    //   data: values1,
    //   backgroundColor: '#f2e6ee',
    // },
    // {
    //   borderWidth: 0,
    //   stack: '2018',
    //   label: '2018',
    //   data: values2018,
    //   backgroundColor: '#d3adc7',
    //   barPercentage: 1,
    // },
    {
      borderWidth: 0,
      stack: '2019',
      label: '2019',
      data: values2019,
      backgroundColor: '#9b005b',
      barPercentage: 1,
    },
    {
      borderWidth: 0,
      stack: '2020',
      label: '2020',
      data: values2020,
      barPercentage: 1,
    },
    {
      borderWidth: 0,
      stack: '2021',
      label: '2021',
      data: values2021,
      backgroundColor: '#f2e6e',
      barPercentage: 1,
    },
    {
      borderWidth: 0,
      stack: '2022',
      label: '2022',
      data: values2022,
      backgroundColor: '#d3adc7',
      barPercentage: 1,
    },
  ]

  return (
    <div className="text-content accordion-content accordion-table">
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <RSRLMultipleBar
        key={slug}
        labels={labels}
        datasets={datasets}
        ylabel={'Nombre de personnes'}
        xlabel={"Taux d'occupation"}
      />
      <div
        className="afterCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    </div>
  )
}

const query = graphql`
  query {
    allRsrlIndicateursXlsxOccupation {
      edges {
        node {
          TAUX
          _2018
          _2019
          _2020
          _2021
        }
      }
    }
  }
`
